import { createStore } from "owa-satcheljs";
import type { SearchFolderDefinitionInfo, SearchFolderDefinitionsMap } from "owa-folders-constants";

export interface ExpiredSearchFolderStore {
    expiredDefinitions: SearchFolderDefinitionsMap;
}

const defaultStore: ExpiredSearchFolderStore = {
    expiredDefinitions: {},
};

export const getExpiredSearchFolderStore: () => ExpiredSearchFolderStore = createStore<ExpiredSearchFolderStore>("expiredSearchFolderStore", defaultStore);

export function isSearchFolderExpired(searchFolderId: string): boolean {
    return !!getExpiredSearchFolderStore().expiredDefinitions[searchFolderId];
}

export function getExpiredSearchFolderDefinition(searchFolderId: string): SearchFolderDefinitionInfo | undefined {
    return getExpiredSearchFolderStore().expiredDefinitions[searchFolderId];
}
